export default {
    install: function(app) {
      app.config.globalProperties.$filters = {
        ...app.config.globalProperties.$filters,
        prettyPrice: function(value) {
          if (value < 0 || !isFinite(value)) {
            return "- kr.";
          }
   
          // TODO: force DK locale with .toLocaleString('da') (check browser compatibility)
          // https://caniuse.com/#search=tolocalestring
          let displayPrice = value;
   
          // convert from ore to krone
          displayPrice = displayPrice / 100;
   
          if (displayPrice % 1 === 0) {
            displayPrice = displayPrice.toLocaleString("da-DK", {
              maximumFractionDigits: 0,
              minimumFractionDigits: 0
            });
          } else {
            displayPrice = displayPrice.toLocaleString("da-DK", {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2
            });
          }
   
          return displayPrice + " kr.";
        },
      };
    },
   };
   